import Stage1Player3Room from "../shared/Stage1Player3Room";

export default function Five_Players_Stage1_Player3(props) {
  return <Stage1Player3Room {...props} playerCount={5} registerOwner="p2" />;
}